module.exports = __webpack_public_path__ + "static/media/greyTick.f64b0cfd.svg";